/**
 * Seeded PRNG and Shuffle utilities for Online Lessons consistency.
 */

/**
 * Mulberry32 PRNG (Seeded Random)
 * Returns a function that generates a random float between 0 and 1.
 */
export const mulberry32 = (a) => {
    return function() {
        let t = a += 0x6D2B79F5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    }
}

/**
 * Simple string hash to number for seeding purposes (sdbm)
 */
export const hashString = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + (hash << 6) + (hash << 16) - hash;
    }
    return hash >>> 0;
};

/**
 * Fisher-Yates shuffle using a seeded generator
 */
export const seededShuffle = (array, seed) => {
    const shuffleArray = [...array];
    const numericSeed = typeof seed === 'string' ? hashString(seed) : seed;
    const rng = mulberry32(numericSeed);
    
    for (let i = shuffleArray.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [shuffleArray[i], shuffleArray[j]] = [shuffleArray[j], shuffleArray[i]];
    }
    
    return shuffleArray;
};

/**
 * Pick a random element from a pool using a seed
 */
export const seededPick = (pool, seed) => {
    if (!pool || pool.length === 0) return null;
    const numericSeed = typeof seed === 'string' ? hashString(seed) : seed;
    const rng = mulberry32(numericSeed);
    return pool[Math.floor(rng() * pool.length)];
}
